<div class="recent-payments-hold">
  {{ message }}
  <div>
    <button
    type="button"
    class="btn_normal btn_purple"
    (click)="retry()">Retry</button>
  </div>
</div>
